import { CssBaseline } from '@mui/material';
import {
  createTheme,
  StyledEngineProvider,
  type ThemeOptions,
  ThemeProvider,
} from '@mui/material/styles';
import type { ReactNode } from 'react';
import breakpoints from './breakpoints';
import componentsOverride from './overrides';
import palette from './palette';
import shadows, { customShadows } from './shadows';
import typography from './typography';

type Props = {
  children: ReactNode;
};

export default function FaksThemeProvider({ children }: Props) {
  const isLight = true; // keeping the logic of light/black in case we want it later

  const themeOptions: ThemeOptions = {
    palette: isLight ? palette.light : palette.dark,
    typography,
    breakpoints,
    shape: { borderRadius: 8 },
    direction: 'ltr',
    shadows: isLight ? shadows.light : shadows.dark,
    customShadows: isLight ? customShadows.light : customShadows.dark,
  };

  const theme = createTheme(themeOptions);

  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
